/**
 * CustomerScopeChip — intentionally disabled.
 *
 * The CustomerContextBanner fixed at the top of every portal page already
 * shows the active customer. Rendering the same "For [Customer]" chip inside
 * every dialog is redundant. This component returns null so all existing
 * call sites compile unchanged.
 *
 * Re-enable (restore original implementation from git history) if a context
 * where the banner isn't visible ever needs it.
 */
export function CustomerScopeChip() {
  return null;
}
